(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- sticky header state ---- */
  var header = document.querySelector('.ap-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- mobile drawer ---- */
  var drawer = document.getElementById('apDrawer');
  var openBtn = document.querySelector('[data-drawer-open]');
  if (drawer && openBtn) {
    var closeDrawer = function () {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    };
    openBtn.addEventListener('click', function () {
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || (e.target.closest && e.target.closest('[data-drawer-close]'))) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ---- product gallery: clickable thumbnails ---- */
  var mainImg = document.querySelector('.ap-gallery .main img');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-ap-thumb]'));
  if (mainImg && thumbs.length) {
    var pick = function (btn) {
      var full = btn.getAttribute('data-full');
      if (!full || btn.classList.contains('is-active')) return;
      thumbs.forEach(function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      var inner = btn.querySelector('img');
      var apply = function () {
        mainImg.src = full;
        if (inner) mainImg.alt = inner.alt || '';
        mainImg.classList.remove('is-swapping');
      };
      if (reduced) { apply(); return; }
      mainImg.classList.add('is-swapping');
      window.setTimeout(apply, 150);
    };
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { pick(btn); });
    });
  }

  if (reduced) return;

  /* ---- scroll reveal with stagger ---- */
  var targets = document.querySelectorAll('.ap-sec-head, .ap-pcard, .ap-step, .ap-why-item, .ap-hero-body, .ap-quote, .ap-cta, .ap-benefit-card, .ap-cartrow, .ap-pagecard, .ap-trust span');
  targets.forEach(function (el) {
    el.classList.add('fx');
    var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains('fx'); }) : [];
    var idx = siblings.indexOf(el);
    if (idx > 0) el.style.transitionDelay = Math.min(idx * 90, 450) + 'ms';
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) { io.observe(el); });
  } else {
    targets.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- 3D tilt on product cards (fine pointers only) ---- */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.ap-pcard').forEach(function (card) {
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'translateY(-8px) perspective(900px) rotateX(' + (-y * 6) + 'deg) rotateY(' + (x * 7) + 'deg)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---- magnetic buttons ---- */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.ap-btn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        btn.style.transform = 'translate(' + (x * 8) + 'px,' + (y * 6 - 2) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }
})();